const messages = {
    pt: {
        translations: {
            login: {
                label1: 'seu login em strateegia',
                label2: 'sua senha em strateegia',
                button: 'entrar'
            },
            main: {
                link: 'link para a jornada',
                heading: 'atas de reuniões', 
                placeholderProj: 'escolha o projeto', 
                placeholderMap: 'escolha o mapa', 
            },
            checkpointReport: {
                place: 'local',
                date: 'data',
            },
            mapList: {
                list: 'todos'
            }
        }
    }
};

export { messages };

